import { api } from '@/shared/api/api';

export const fetchListUsersTable = async userId => {
  try {
    const { data: resData } = await api.get(`/api/users/getList`);

    const mappedData = resData.map((el, i) => ({ ...el, key: i + 1 })).filter(el => el.id !== userId);

    return mappedData;
  } catch (error) {
    console.error('error-fetchDataChartPage >>>', error);
  }
};
